import type { PlayerAnimationSource } from '../types';

export function hasCompleteScheduledSequencePlayback(
  animation: PlayerAnimationSource | undefined,
  loadedClipCount: number,
): boolean {
  if (animation?.type !== 'sequence' || loadedClipCount <= 0) {
    return false;
  }

  const { clipStartFrames, totalDurationFrames, urls } = animation;

  return (
    clipStartFrames !== undefined &&
    totalDurationFrames !== undefined &&
    totalDurationFrames > 0 &&
    clipStartFrames.length > 0 &&
    clipStartFrames.length === loadedClipCount &&
    clipStartFrames.length === urls.length
  );
}
